<svg
  xmlns="http://www.w3.org/2000/svg"
  width="19"
  height="18"
  viewBox="0 0 19 18"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.5253 1.97558C15.9719 1.4222 15.0747 1.4222 14.5213 1.97558L9.50092 6.99595L4.48054 1.97558C3.92716 1.4222 3.02995 1.4222 2.47656 1.97558C1.92318 2.52897 1.92318 3.42618 2.47656 3.97956L7.49694 8.99993L2.47656 14.0203C1.92318 14.5737 1.92318 15.4709 2.47656 16.0243C3.02995 16.5777 3.92716 16.5777 4.48054 16.0243L9.50092 11.0039L14.5213 16.0243C15.0747 16.5777 15.9719 16.5777 16.5253 16.0243C17.0787 15.4709 17.0787 14.5737 16.5253 14.0203L11.5049 8.99993L16.5253 3.97956C17.0787 3.42618 17.0787 2.52897 16.5253 1.97558Z"
    fill="#333333"
  />
</svg>
